import type { FC } from 'react';
import type { UIComponentBase } from '@components/types';
import clsx from 'clsx';

export const RowPrefix: FC<UIComponentBase> = ({ children, className }) => {
  return <div className={clsx('text-info-800 h-fit w-fit pl-2 text-sm', className)}>{children}</div>;
};
